import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const useLanguage = (): string => {
    const { locale } = useParams();
    const [language, setLanguage] = useState(locale || 'en_GB');

    useEffect(() => {
        setLanguage(locale || 'en_GB');
    }, [locale]);

    return language;
}
